import { useState } from 'react';

import { Headline, Text } from '~components/Typography';
import { useTranslations } from '~i18n/hooks';
import { Avatar } from '~shared/ui/organisms';

import ChevronLeft from '../../../../../public/assets/icons/chevron-left.svg';
import ChevronRight from '../../../../../public/assets/icons/chevron-right.svg';
import type { MappedDialogParticipant } from '../../types';
import {
	Container,
	DirButton,
	Flex1,
	Heading,
	HeadingBottom,
	HeadingTop,
	Item,
	ItemInfo,
	Panel,
} from './styles';

type Props = {
	bots: MappedDialogParticipant[];
	onClick: (botClientId: number, botName: string) => void;
};

export const ContactsSlider = ({ bots, onClick }: Props) => {
	const [activeIndex, setActiveIndex] = useState(0);

	const bot = bots[activeIndex];
	const { clientId, name, avatar, avatarFallback, paymentOptionLevel } = bot;
	const t = useTranslations('Chats');

	return (
		<Container>
			<Heading>
				<HeadingTop>
					<Flex1>
						<Headline size="M" align="left">
							{t('levelCharacterBonusTitle', { level: paymentOptionLevel })}
						</Headline>
					</Flex1>
					<DirButton
						type="button"
						disabled={activeIndex === 0}
						onClick={() => setActiveIndex((prev) => prev - 1)}
					>
						<ChevronLeft />
					</DirButton>
					<DirButton
						type="button"
						disabled={activeIndex === bots.length - 1}
						onClick={() => setActiveIndex((prev) => prev + 1)}
					>
						<ChevronRight />
					</DirButton>
				</HeadingTop>
				<HeadingBottom>
					<Text size="M" align="left" color="semi-transparent">
						{t('levelCharacterBonusText')}
					</Text>
				</HeadingBottom>
			</Heading>
			<Panel>
				<Item type="button" onClick={() => onClick(clientId, name)}>
					<Avatar
						avatar={avatar}
						avatarFallback={avatarFallback ?? undefined}
					/>
					<ItemInfo>
						<Text size="L" align="left">
							{name}
						</Text>
					</ItemInfo>
				</Item>
			</Panel>
		</Container>
	);
};
